/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

const BASE_PATH = 'https://happymdev.netfarm.it';

export const environment = {
    production: true,
    google_maps_api_key: 'AIzaSyBgZtqYx-ZZjLo850NnMEOLwOkMlxu9Oko',
    custom_base_path_api: BASE_PATH + '/api/v3',
    custom_base_path_images: BASE_PATH,
    moodle_path: 'https://happymoodle.netfarm.it',
    prems_path_no: 'https://osservatoriopremsproms.santannapisa.it/prems_toscana',
    prems_path: 'http://localhost:4200',
    languages: ['it', 'en', 'fr', 'es', 'sq', 'ar', 'zh', 'ro'],
    arpa_oauth2_host: 'https://trial.auth.regione.toscana.it',
	arpa_oauth2_logout: 'https://trial.auth.regione.toscana.it/auth-trial/realms/rt/protocol/openid-connect/logout',
    min_auth_level_strong: 1,
    debug: false
};


